import { GetInferredFromRaw } from '@thinknimble/tn-models'
import { z } from 'zod'
import { baseModelShape } from '../base-model'
import { userShape } from '../user'
import { organizationShape } from '../user/models'

export const accountTypeKeyEnum = {
  savings: 'savings',
  checking: 'checking',
  cash: 'cash',
  credit_card: 'credit_card',
  debit_card: 'debit_card',
  credit_line: 'credit_line',
} as const

export type AccountTypeKeyValues = (typeof accountTypeKeyEnum)[keyof typeof accountTypeKeyEnum]

export const accountTypeLabelMap = {
  [accountTypeKeyEnum.savings]: 'Savings',
  [accountTypeKeyEnum.checking]: 'Checking',
  [accountTypeKeyEnum.cash]: 'Cash',
  [accountTypeKeyEnum.credit_card]: 'Credit Card',
  [accountTypeKeyEnum.debit_card]: 'Debit Card',
  [accountTypeKeyEnum.credit_line]: 'Credit Line',
}

export const paymentAccountShape = {
  ...baseModelShape,
  name: z.string(),
  organization: z.string().nullable(),
  organizationRef: z.object(organizationShape).nullable(),
  user: z.string().nullable(),
  userRef: z.object(userShape).nullable(),
  accountLastFour: z.string().nullable(),
  institution: z.string().nullable(),
  accountType: z.enum(accountTypeKeyEnum).nullable(),
}

export const createPaymentAccountShape = {
  name: z.string(),
  organization: z.string().optional(),
  user: z.string().optional(),
  accountLastFour: z.string(),
  institution: z.string().optional().nullable(),
  accountType: z.string(),
}

export const paymentAccountFiltersShape = {
  search: z.string(),
  user: z.string().uuid(),
  organization: z.string().uuid(),
}

export type PaymentAccount = GetInferredFromRaw<typeof paymentAccountShape>
export type CreatePaymentAccountType = GetInferredFromRaw<typeof createPaymentAccountShape>
export type PaymentAccountFilters = GetInferredFromRaw<typeof paymentAccountFiltersShape>
